import { connect } from 'react-redux'
import { includes } from 'lodash'
import { getTop } from 'reduxpath/ducks/Top'

import {
  getPitch,
  changeRadioStatus,
  putGetPaidStatus,
} from 'reduxpath/ducks/Project/Pitch'

import { getPermission } from 'reduxpath/ducks/Impersonate'

import Summary from './units'

function mapStateToProps(state) {
  const { countryTax, data, poCreator, top } = state.ProjectDetail
  const pitches = state.ProjectPitch.data.pitches
  const calculate = pitches.map(item => {
    /*
      isNew created because there is differences between
      current pitch calculator and old pitch calculator
    */
    const isNew = new Date(item.updatedAt) >= new Date('2019-01-24')
    const totalPrice = item.price * item.quantity
    const gcCommPercentage = 0.2
    const gcCommission = item.gcComm || totalPrice * gcCommPercentage
    const subtractComission = isNew ? totalPrice : totalPrice - gcCommission
    let withWht = item.profile.businessType === 'company' ? 0 : countryTax.wht / 100
    withWht =
      withWht === (countryTax.wht / 100 > 0 && item.profile.taxNumber)
        ? countryTax.whtTin / 100
        : withWht
    const addVat = item.profile.isVatRegistered
      ? subtractComission * (countryTax.vat / 100)
      : 0
    const subtractWht = subtractComission * withWht
    const finalPrice = isNew ? totalPrice : subtractComission + addVat - subtractWht
    return {
      id: item.id,
      totalPrice,
      gcCommission,
      subtractComission,
      businessType: data.profile.businessType,
      finalPrice,
    }
  })

  const isProjectStarted = state.ProjectDetail.data.status >= 1

  return {
    selectedPitchLoading: state.ProjectPitch.selectedPitchLoading,
    selectedRadioPitchStatus: state.ProjectPitch.selectedRadioPitchStatus,

    data: state.ProjectDetail.data,
    pitches: state.ProjectPitch.data.pitches,
    top: getTop(top.rows[0]),
    quotation: state.ProjectDetail.quotation,
    invoices: state.ProjectPaymentConfirmation.invoices,
    calculate,
    poCreator,
    userEmail: state.Auth.me.user.email,
    loanStatuses: state.Reference.loanStatuses,
    isProjectStarted,
  }
}

const mapDispatchToProps = dispatch => ({
  handleRadioStatus(status, order) {
    return e => {
      const value = e.target.value
      if (value !== status) {
        const searchParam = content => {
          if (content === 'all') {
            return {
              order,
            }
          } else if (content === 'approved') {
            return {
              order,
              status: 2,
            }
          } else if (content === 'withdraw') {
            return {
              order,
              status: 3,
            }
          } else if (content === 'draft') {
            return {
              order,
              status: 4,
            }
          }
          return {
            order,
            status: { '!': 2 },
          }
        }
        dispatch(changeRadioStatus(value))
        dispatch(getPitch(searchParam(value)))
      }
    }
  },

  goesTopPlatform(profileId, userEmail, pageDestination, typeDestination) {
    return () => {
      dispatch(getPermission(profileId, userEmail, pageDestination, typeDestination))
    }
  },

  putGetPaidStatus(loanId, newStatus, cb = () => {}) {
    dispatch(putGetPaidStatus(loanId, newStatus, () => cb(newStatus)))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(Summary)
